import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useToast } from "hooks/useToast";
import { useMarkVendorAsVoidMutation } from "store/apis/taskMerchants";
import { ModalProps } from "types/utils/modal";

type MarkVendorAsVoidProps = ModalProps & {
  merchantId: string;
  groupId: string;
  season: string;
  taskId: string;
};

export const MarkVendorAsVoid = ({
  isOpen,
  close,
  merchantId,
  groupId,
  season,
  taskId,
}: MarkVendorAsVoidProps) => {
  const [markAsVoid, { isLoading: isEditing }] = useMarkVendorAsVoidMutation();
  const { alertToast, successToast } = useToast();

  const markVendorAsVoid = async () => {
    try {
      await markAsVoid({
        groupId,
        merchantId,
        payload: {
          season,
          task_id: taskId,
        },
      }).unwrap();
      close();
      successToast({ message: "Vendor has been updated" });
    } catch (error: any) {
      alertToast({ message: error?.data?.error?.message });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Void Filing </Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-lg t-text-text-60">
            Are you sure you want to void the filing? This action cannot be
            undone and will reset the vendor amount to zero.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="t-flex t-justify-end t-gap-3">
            <Modal.RawClose asChild>
              <Button>Cancel</Button>
            </Modal.RawClose>
            <Button
              customType="danger"
              isLoading={isEditing}
              disabled={isEditing}
              onClick={markVendorAsVoid}
            >
              Void filing
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
